import img_effects from '@/base/img_effects'
import linkData from '@/base/linkData'
import { create_title } from '@/base/titleData';
import { box_shadow_style_add} from "@/base/widgets_data_compatible";
import {
  flod_text_one_list
} from '@/base/base';
export default {
  img_effects, //不知道这个是啥 但是去掉会报错
  pc_widgets_infor: {
     //标题对象
    title: create_title('Collapsed text'),
    /* icon_show: true, // 图标显示和隐藏
    icon_img: {
      radio_val: 'default',
      default: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png',// 图标的URL
      },
      custom: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png', // 图标的URL
      }
    }, */
    show_type: 'default', //展开方式
    //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    // 标题文字
    title_font: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },
    // 内容文字
    content_font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    borderRadius: {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0
      }
    },
    barBorder: {
      radio_val: 'default',
      default: {
        border_width: 0,
        border_left_width: 0,
        border_right_width: 0,
        border_top_width: 0,
        border_bottom_width: 0,
        border_color: 'rgba(0,0,0,1)',
        border_select_color:'rgba(0,0,0,1)',
        border_style: 'solid',
        border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
      },
      custom: {
        border_width: 0,
        border_left_width: 0,
        border_right_width: 0,
        border_top_width: 0,
        border_bottom_width: 0,
        border_color: 'rgba(0,0,0,1)',
        border_select_color:'rgba(0,0,0,1)',
        border_style: 'solid',
        border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
      }
    },
    boxShadow: { //  rgba(0, 0, 0, 0.1) 0 0 15px;
      radio_val: 'default',
      default: {
        direction: 'outset',
        x: 0,
        y: 0,
        spread: 0,
        blur: 0,
        color: 'rgba(0,0,0,0)',
        seColor: 'rgba(0,0,0,0)',
      },
      custom: {
        direction: 'outset',
        x: 0,
        y: 0,
        spread: 0,
        blur: 4,
        color: 'rgba(0,0,0,0.3)',
        seColor: 'rgba(0,0,0,0.5)',
      }
    }
  },
  mb_widgets_infor: {
     //标题对象
    title: create_title('Collapsed text'),
    // 标题文字
    title_font: {
      radio_val: 'default',
      default: {
        fontSize: 14,
        fontWidth: 'normal',
        fontColor: 'rgba(255,255,255,1)',
        fontSeColor: 'rgba(255,255,255,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 12,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },

    },
    // 内容文字
    content_font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        // selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        // selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
  },
  // https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (25).png
  // https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (24).png
  listArr: {
    content_type: 'custom', // 内容类型：custom 自定义文本，faq FAQ
    list: [{ ...flod_text_one_list() }],
    faqList: [{ question: 'FAQ内容将从详情中获取', answer: '', editorId: '' }],
    // link: linkData,
    // title: '折叠文本',
    // content: '请输入内容',
    icon_show: 'true', // 图标显示和隐藏
    icon_width:20,
    list_padding:0, // 间距
  },
  version: 1,
}



// WEBPACK FOOTER //
// ./src/widgets/basic_flod_text_list/style.js